(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter-reminder/assets/javascripts/payfooter-reminder-animations.js') >= 0) return;  svs.modules.push('/components/tur/payfooter-reminder/assets/javascripts/payfooter-reminder-animations.js');


'use strict';

svs = svs || {};
svs.tur = svs.tur || {};
svs.tur.payfooter_reminder = svs.tur.payfooter_reminder || {};
class PayfooterReminderAnimations {
  constructor(element, bubble) {
    this.element = element;
    this.bubble = bubble;
  }
  dotsUp() {
    return gsap.fromTo(this.element, {
      y: 140,
      opacity: 1
    }, {
      duration: 0.9,
      ease: 'elastic.out(1,0.3)',
      y: 70,
      opacity: 1
    });
  }
  dotsDown() {
    return gsap.to(this.element, {
      duration: 0.2,
      y: 100,
      delay: 0
    });
  }
  arrowUp() {
    return gsap.fromTo(this.bubble, {
      opacity: 0,
      y: 0,
      scale: 0.5
    }, {
      duration: 0.9,
      visibility: 'visible',
      opacity: 1,
      scale: 1,
      y: -68,
      ease: 'elastic.out(1,0.3)'
    });
  }
  arrowWiggle() {
    const tl = gsap.timeline();
    tl.to(this.bubble, {
      duration: 1.5,
      ease: 'linear',
      y: -62
    });
    tl.to(this.bubble, {
      duration: 1.5,
      ease: 'linear',
      y: -68
    });
    return tl;
  }
  arrowMinimize() {
    return gsap.to(this.bubble, {
      y: svs.core.detect.formfactor.mobile() ? -93 : -65,
      scale: 0.6,
      duration: 0.2
    });
  }
  arrowDown() {
    return gsap.to(this.bubble, {
      y: -40,
      duration: 0.3,
      scale: 0.2
    });
  }
}
svs.tur.payfooter_reminder.animations = PayfooterReminderAnimations;

 })(window);